import { useEffect } from 'react';
import PushNotificationPermissionModal from 'src/components/PushNotificationPermissionModal';
import { ModalType } from 'src/types/Modal';
import { LoginUserModalInitPromise, OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const modalData = [{
  modalProps: {
    key: ModalType.PUSH_NOTIFICATION_PERMISSION,
    component: PushNotificationPermissionModal
  }
}];

/**
 * Notification.permission을 바라본 경우: 'default'인 경우에만 푸시 권한 허용여부 팝업을 노출한다.
 * navigator.permissions.query를 바라본 경우: 'prompt'인 경우에만 푸시 권한 허용여부 팝업을 노출한다.
 */
function resolvePromise(promise: LoginUserModalInitPromise, permission: string) {
  if (promise.ended) return;
  const shouldShow = permission === 'default' || permission === 'prompt';
  promise.resolve(shouldShow ? modalData : null);
}

/**
 * 브라우저의 Notification.permission은 페이지 로드 직후 permission DB가
 * 아직 로딩되지 않아 실제 상태와 다른 값('default')을 반환할 수 있다.
 * navigator.permissions.query()는 DB 로딩 완료 후 정확한 상태를 반환하므로
 * 이를 우선 사용하고, 미지원 브라우저에서는 동기 API로 fallback한다.
 */
const usePushNotificationPermissionModal: OrderedModalHookType = modalPropsPromise => {
  useEffect(() => {
    if (!modalPropsPromise) return;
    if (typeof window === 'undefined' || !('Notification' in window)) {
      modalPropsPromise.resolve(null);
      return;
    }
    let canceled = false;
    if (navigator.permissions?.query) {
      navigator.permissions.query({
        name: 'notifications' as PermissionName
      }).then(status => {
        if (!canceled) resolvePromise(modalPropsPromise, status.state);
      }).catch(() => {
        if (!canceled) resolvePromise(modalPropsPromise, Notification.permission);
      });
    } else {
      resolvePromise(modalPropsPromise, Notification.permission);
    }
    return () => {
      canceled = true;
      if (!modalPropsPromise.ended) {
        modalPropsPromise.resolve(null);
      }
    };
  }, [modalPropsPromise]);
};
export default withLoginUserModalPromise(usePushNotificationPermissionModal);